import ChallengeBlueprint from "./ChallengeBlueprint";

export default abstract class ChallengeBlueprintRepository {
    abstract fetch(): Promise<ChallengeBlueprint[]>
    abstract find(challengeBlueprintId: string): Promise<ChallengeBlueprint|undefined>
}